<template>
  <div>
    {{ item.carrier}}
  </div>
</template>

<script>
export default {
  props: ['item']
}
</script>

<style scoped>

</style>
